export type BusinessGroupCreationFollowUp = {
  page: {
    kind: "detail";
    brandId: string;
    tab: "integrations";
  };
  dialog: { kind: "closed" };
};

/**
 * A newly created Business group opens on its App accounts tab.
 * Assigning an app account remains an explicit follow-up action.
 */
export const getBusinessGroupCreationFollowUp = (
  brandId: string,
): BusinessGroupCreationFollowUp => ({
  page: { kind: "detail", brandId, tab: "integrations" },
  dialog: { kind: "closed" },
});
